module.exports = __webpack_public_path__ + "img/15fff79.png";